(function ($) {
  Drupal.behaviors.productAccordion = {
    attach: function (context, settings) {
      var $accordion = $('.product-full__accordion__container', context);
      var $titles = $('.js-accordion__title', context);
      var $panels = $('.js-accordion__panel', context);
      var params = {
        titles: $titles,
        panels: $panels
      };
      var accordion = new site.BasicAccordion(params);
    }
  };
})(jQuery);
